<template>
  <div class="waitting-wrapper">
    <div class="waitting-card">
      <div class="waitting-icon">
        <icon icon-class="waitting"></icon>
      </div>
      <div class="waitting-text">
        <p>您的医生入驻资料<span>正在审核中…</span></p>
        <p>请耐心等待</p>
        <p>如有疑问，请<a :href="`tel:${serviceNumber}`">联系客服</a></p>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .waitting-wrapper{
    width: 100%;
    height: 100vh;
    background: @linear;
    padding: 40px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    .waitting-card{
      width: 100%;
      height: 100%;
      background: #FFF;
      border-radius: 5px;
      box-shadow: @box-shadow;
      text-align: center;
      .waitting-icon{
        margin-top: 128px;
        svg{
          font-size: 72px;
        }
      }
      .waitting-text{
        margin-top: 27px;
        font-weight: bold;
        p{
          margin-bottom: 12px;
          color: #666;
          font-size: 14px;
          line-height: 14px;
          span{
            color: @xile;
            font-weight: bold;
          }
          a{
            color: @black;
            text-decoration: underline;
            margin-left: 4px;
          }
        }
      }
    }
  }
</style>

<script type="text/javascript">
  export default {
    data() {
      return {}
    },
    computed: {
      serviceNumber() {
        return this.$store.state.servicePhone
      }
    },
    mounted() {}
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/Index/waittingEnter.vue